import { useDispatch } from 'react-redux';
import { campaignPageLogPageViewRequest } from '../../../_redux/_actions';

export const useLogContentPageView = () => {
  const dispatch = useDispatch();

  const logPageView = (contentTypeId, pageId) => {

   if(pageId !== '0'){
    dispatch(
        campaignPageLogPageViewRequest({
          contentTypeId,
          pageId,
        })
      );
    };
   }

  return logPageView;
};